import { NotebookPage } from "../../../note";
import { NoteBlock } from "../block";
import { v4 as uuidv4 } from "uuid";

export interface PageBlock extends NoteBlock {
  type: "omega/query-omega/page/block/page-block/PageBlock";
  "sub-page-id": string;
}

export const newNotePageBlock = (config: {
  parent: NotebookPage;
  child: NotebookPage;
  blockIndex: number;
}) => {
  const { parent, child, blockIndex } = config;
  const pageBlock: PageBlock = {
    "app-id": parent["app-id"],
    "block-id": uuidv4(),
    "block-index": blockIndex,
    "page-id": parent["page-id"],
    "sub-page-id": child["page-id"],
    type: "omega/query-omega/page/block/page-block/PageBlock",
  };
  return pageBlock;
};

export const isNotePageBlock = (block: NoteBlock) => {
  return block.type === "omega/query-omega/page/block/page-block/PageBlock";
};
